import { Injectable } from '@angular/core';
import { FileDownloadService } from './file-download.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';


/**
 * ファイルダウンロード前に確認処理を行い、
 * ファイルダウンロードAPIの呼び出し制御を行うクラス
 *
 * @export FileDownloadConfirmService
 * @class FileDownloadConfirmService
 */
@Injectable()
export class FileDownloadConfirmService {

  private _filePath = String('');
  private _fileName = String('');
  private _showCompleteAlert = Boolean(false);
  private _downloadSuccessFunction: Function;

  /**
   * Creates an instance of FileDownloadConfirmService.
   * @param {PlessDialogServiceSub} dialogService ダイアログサービス
   * @param {FileDownloadService} fileDownloadService ファイルダウンロードサービス
   * @memberof FileDownloadConfirmService
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadService: FileDownloadService
  ) { }

  /**
   * ファイルダウンロード前に確認を行う
   * ※現在はshowComplateAlate, downloadSuccessFunctionは未実装
   *
   * @param {string} filePath ダウンロードファイルパス
   * @param {string} fileName 保存時ファイル名
   * @param {boolean} [showComplateAlert=true] ダウンロード完了時アラート表示フラグ
   * @param {Function} [downloadSuccessFunction=null] ダウンロード完了時後続処理
   * @param {Function} [beforeDownloadFunction=null] ダウンロード前処理
   * @memberof FileDownloadConfirmService
   */
  public show(filePath: string, fileName: string,
    showComplateAlert = true, downloadSuccessFunction: Function = null, beforeDownloadFunction: Function = null): void {
    this._filePath = filePath;
    this._fileName = fileName;
    this._showCompleteAlert = showComplateAlert;
    this._downloadSuccessFunction = downloadSuccessFunction;

    this.dialogService.openAlert('ファイルをダウンロードする準備ができました。\n続行しますか？', 'Q',
      [PlessAlert.No, PlessAlert.Yes],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          if (beforeDownloadFunction) {
            beforeDownloadFunction(() => {
              this.download(closeDetail);
            });
          } else {
            this.download(closeDetail);
          }
        }
      }
    );
  }

  /**
   * ダウンロード前の確認で【はい】が押下されている際に、
   * ファイルダウンロードサービスを呼び出す
   *
   * @private
   * @param {*} closeDetail 確認メッセージ選択結果
   * @memberof FileDownloadConfirmService
   */
  private download(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // ダウンロード
      this.fileDownloadService.execute(this._filePath, this._fileName);
    }
  }
}
